/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maximum_Frame_GapInputs */

const en_maximum_frame_gap = /** @type {(inputs: Maximum_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum Frame Gap`)
};

const fr_maximum_frame_gap = /** @type {(inputs: Maximum_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Écart d’images maximal`)
};

const de_maximum_frame_gap = /** @type {(inputs: Maximum_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximaler Rahmenabstand`)
};

const it_maximum_frame_gap = /** @type {(inputs: Maximum_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distanza massima tra i fotogrammi`)
};

const ru_maximum_frame_gap = /** @type {(inputs: Maximum_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальный разрыв между кадрами`)
};

const es_maximum_frame_gap = /** @type {(inputs: Maximum_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espacio máximo entre marcos`)
};

const zh_cn2_maximum_frame_gap = /** @type {(inputs: Maximum_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大帧间隙`)
};

const ja_maximum_frame_gap = /** @type {(inputs: Maximum_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大フレームギャップ`)
};

const hi_maximum_frame_gap = /** @type {(inputs: Maximum_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिकतम फ्रेम अंतर`)
};

const pt_pt2_maximum_frame_gap = /** @type {(inputs: Maximum_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaço máximo entre quadros`)
};

/**
* | output |
* | --- |
* | "Maximum Frame Gap" |
*
* @param {Maximum_Frame_GapInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const maximum_frame_gap = /** @type {((inputs?: Maximum_Frame_GapInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maximum_Frame_GapInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_maximum_frame_gap(inputs)
	if (locale === "de") return de_maximum_frame_gap(inputs)
	if (locale === "it") return it_maximum_frame_gap(inputs)
	if (locale === "ru") return ru_maximum_frame_gap(inputs)
	if (locale === "es") return es_maximum_frame_gap(inputs)
	if (locale === "zh-CN") return zh_cn2_maximum_frame_gap(inputs)
	if (locale === "ja") return ja_maximum_frame_gap(inputs)
	if (locale === "hi") return hi_maximum_frame_gap(inputs)
	if (locale === "pt-PT") return pt_pt2_maximum_frame_gap(inputs)
	return en_maximum_frame_gap(inputs)
});